import React from 'react'

const LowCoolant = ({ width = '50px', height = '38px', color }) => (
  <svg viewBox="0 0 50 38" version="1.1" width={width} height={height}>
    <title>Icon/Dashboard/ABS Copy 4@3x</title>
    <g id="Desktop" stroke="none" strokeWidth="1" fill="none" fillRule="evenodd" strokeLinecap="round" strokeLinejoin="round">
      <g id="Interior_Lights_D" transform="translate(-844.000000, -646.000000)" stroke={color} strokeWidth="1.21052857">
        <g id="Group" transform="translate(837.000000, 633.000000)">
          <g id="ICOPath-LowCoolant" transform="translate(8.000000, 13.600000)">
            <line x1="24.0605264" y1="0" x2="24.0605264" y2="24.8" id="Path"></line>
            <line x1="35.2" y1="2.46052643" x2="24" y2="2.46052643" id="Path"></line>
            <line x1="35.2" y1="10.4605264" x2="24" y2="10.4605264" id="Path"></line>
            <line x1="35.2" y1="17.6605264" x2="24" y2="17.6605264" id="Path"></line>
            <path d="M0,29.0259104 C0,29.0259104 3.97511949,26.717612 7.75155503,29.0259104 C11.5279906,31.3342087 13.9130383,30.2850052 16,29.1308561" id="Path"></path>
            <path d="M48,29.0259104 C48,29.0259104 44.0248805,26.717612 40.248445,29.0259104 C36.4720094,31.3342087 34.0869617,30.2850052 32,29.1308561" id="Path"></path>
            <path d="M6.4,35.3414026 C6.4,35.3414026 9.62060177,38.204302 15.1491827,35.9083086 C19.8289238,33.9647849 20.3375886,36.6371177 24,36.6371177" id="Path"></path>
            <path d="M41.6,35.3414026 C41.6,35.3414026 38.3793982,38.204302 32.8508173,35.9083086 C28.1710762,33.9647849 27.6624114,36.6371177 24,36.6371177" id="Path"></path>
            <circle id="Oval" cx="24" cy="28" r="3.2"></circle>
          </g>
        </g>
      </g>
    </g>
  </svg>
)
export default LowCoolant
